module.exports = __webpack_public_path__ + "img/portal.271ac278.svg";